<template>
  <div class="mb-10">
    <div class="flex items-center mb-15">
      <div class="text-xl font-bold text-text leading-tight">{{$t('dynamicTitle')}}</div>
      <div class="text-md text-text-ternary font-bold ml-auto mr-12">
        {{$t('fromDate')}} {{ humanized_date(filters.date.start) }} {{$t('toDate')}} {{ humanized_date(filters.date.end) }}
      </div>
      <div class="grid grid-cols-2 col-gap-4">
        <div class="toggle-chart-icon"
             :class="filters.main_chart_type === 'line' && 'active'"
             @click="updateFilter({name:'main_chart_type',value:'line'})">
          <IconChartLine class="w-5-6"/>
        </div>
        <div class="toggle-chart-icon"
             :class="filters.main_chart_type === 'bar' && 'active'"
             @click="updateFilter({name:'main_chart_type',value:'bar'})">
          <IconChartBars class="w-5-6"/>

        </div>
      </div>
    </div>
    <div class="relative" style="height: 338px;">
      <ChartLoadingOverlay v-if="chart_data.dirty"/>
      <LineChart v-if="!chart_data.dirty && filters.main_chart_type==='line'"
                 chart-id="chart-dynamics"
                 :chart-data="timelineLineChartData(filters.income_structure)"
                 :height="338"
                 @click="setChartPoint($event)"/>
      <BarChart v-else-if="!chart_data.dirty && filters.main_chart_type==='bar'"
                chart-id="chart-dynamics"
                :chart-data="timelineBarChartData(filters.income_structure)"
                :height="338"
                @click="setChartPoint($event)"/>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import ChartLoadingOverlay from "@/components/cabinet/Money/Reports/charts/ChartLoadingOverlay";
import LineChart from "@/components/cabinet/Money/Reports/charts/LineChart";
import BarChart from "@/components/cabinet/Money/Reports/charts/BarChart";
import IconChartBars from "@/components/icons/IconChartBars";
import IconChartLine from "@/components/icons/IconChartLine";

export default {
  name: "ReportIncomeDynamics",
  components: {IconChartLine, IconChartBars, BarChart, LineChart, ChartLoadingOverlay},
  computed: {
    ...mapState('reports/report_filters', ['filters']),
    ...mapState('reports/report_income', ['chart_data', 'chart_data_in_point', 'pagination', 'main_chart_selected_point']),
    ...mapGetters('reports/report_income', ['timelineLineChartData', 'timelineBarChartData']),
  },
  methods: {
    ...mapMutations('reports/report_filters', ['updateFilter']),
    ...mapMutations('reports/report_income', ['setChartPoint']),
    humanized_date(val) {
      return this.$moment(val).format('DD.MM.YYYY')
    },
  },
  i18n:{
    messages:{
      en:{
        dynamicTitle:'Income dynamics',
        fromDate:'from',
        toDate:'to'
      },
      ru:{
        dynamicTitle:'Динамика доходов',
        fromDate:'с',
        toDate:'по'
      },
    }
  }
}
</script>

<style scoped lang="scss">
.toggle-chart-icon {
  @apply rounded border border-border flex items-center justify-center w-10-5 h-10-5 text-icon transition duration-200 cursor-pointer;
  &:hover {
    @apply border-border-hover;
  }

  &.active {
    @apply text-icon-hover;
  }
}
</style>